import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const PhilosophySection = () => {
  const { t } = useLanguage();
  
  return (
    <section 
      id="philosophy"
      className="relative min-h-screen bg-[#030303] py-32 md:py-48 overflow-hidden"
      data-testid="philosophy-section"
    >
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #2bfecd 0.5px, transparent 0)`,
          backgroundSize: '60px 60px'
        }} />
      </div>
      
      {/* Ambient Light */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#2bfecd] opacity-[0.02] blur-[200px] rounded-full" />
      
      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10">
        {/* Title */}
        <motion.h2 
          className="font-cinzel text-3xl md:text-5xl tracking-[0.15em] uppercase text-center mb-16 text-white"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          {t('philosophy.title')}
        </motion.h2>
        
        {/* Philosophy Text */}
        <div className="space-y-8 max-w-3xl mx-auto">
          {['text1', 'text2', 'text3'].map((key, index) => (
            <motion.p 
              key={key}
              className="text-base md:text-lg leading-[2.2] tracking-wide text-white/60 text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.3 + index * 0.2 }}
            >
              {t(`philosophy.${key}`)}
            </motion.p>
          ))}
        </div>
        
        {/* Three Pillars Preview */}
        <motion.div 
          className="flex justify-center gap-16 md:gap-24 mt-24"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          {[
            { num: 'I', label: 'HEAT' },
            { num: 'II', label: 'COLD' },
            { num: 'III', label: 'REST' }
          ].map((item, index) => (
            <motion.div 
              key={item.num}
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 1 + index * 0.15 }}
            >
              <span className="block font-cinzel text-4xl md:text-6xl text-[#2bfecd]/20 mb-3">
                {item.num}
              </span>
              <span className="text-[10px] tracking-[0.4em] uppercase text-white/40">
                {item.label}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PhilosophySection;
